<template>
  <div class="mobile-companies-card">
    <img src="/images/promo/connect-features/mobile-companies-card.svg" alt="" />
  </div>
</template>

<script>
export default {};
</script>
